<template>
  <div>

        <md-table v-model="cinovi" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Naslov">{{ item.cin.cin_naslov }}</md-table-cell>
        <md-table-cell md-label="Način">{{ item.cin.cin_nacin_negiranja }}</md-table-cell>
        <md-table-cell md-label="Opis">{{ item.cin.cin_citat_opis.substring(0,36) }}</md-table-cell>
        <md-table-cell md-label="Link"><a :href="item.cin.cin_link">{{ item.cin.cin_link.substring(0,18) }}</a></md-table-cell>
        <md-table-cell md-label="Država">{{ item.cin.cin_drzava }}</md-table-cell>
        <md-table-cell md-label="Negator">{{ item.negator.negator_ime_naziv }}</md-table-cell>
        <md-table-cell md-label="Platforma">{{ item.platforma.platforma_naziv }}</md-table-cell>
        <md-table-cell md-label="">
            <router-link :to="'/editstg/'+item.cin_id">Izmijeniti</router-link>
        </md-table-cell>
        <md-table-cell md-label="">
            <md-button class="md-danger" @click="start_delete(item.cin_id)">Obrisati</md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog :md-active.sync="open_delete_modal">
      <md-dialog-title>Brisanje neodobrenog unosa</md-dialog-title>

        <div class="md-layout">
          <p class="md-layout-item">Da li ste sigurni da želite <b>bespovratno obrisati</b> ovaj unos? Ne postoji način da se on vrati u slučaju brisanja!</p>
        </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="delete_cin()">Da</md-button>
        <md-button class="md-primary" @click="open_delete_modal=false">Ne</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="open_post_delete_modal">
      <md-dialog-title></md-dialog-title>

        <div class="md-layout">
          <p class="md-layout-item">{{modal_message}}</p>
        </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="close_post_delete_modal">Zatvoriti</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ordered-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: [],
      cinovi: [],
      open_delete_modal: false,
      open_post_delete_modal: false,
      cin_in_deletion: "",
      modal_message: "",
      error_message: "Došlo je do greške prilikom brisanja unosa, molimo pokušajte kasnije ili se obratiti administratoru za pomoć",
      success_message: "Unos je uspješno obrisan"
    };
  },
  methods:{
      approve:function(event)
      {
          
      },
      start_delete: function(cin_id)
      {
        this.open_delete_modal = true,
        this.cin_in_deletion = cin_id
      },
      delete_cin: async function()
      {
        const token = await this.$auth.getTokenSilently()
        axios.delete("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/staging/cin/"+this.cin_in_deletion,
        {headers:{Authorization: `Bearer ${token}`}})
        .then((response) => {
          if (response.status == 200) {
            this.modal_message = this.success_message
          }
          else{
            this.modal_message = this.error_message
          }
          this.open_delete_modal = false
          this.open_post_delete_modal = true
          this.cin_in_deletion = ""
          })  
        //axios call to delete cin
        //close delete modal
        // show success modal

      },
      close_post_delete_modal: function()
      {
        this.open_post_delete_modal = false
        this.$router.push('intermediate')
      }
  },
  mounted: async function(){
      const token = await this.$auth.getTokenSilently()
       axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/staging/cin",
       {headers:{Authorization: `Bearer ${token}`}})
      .then(((response) => {
          this.cinovi = response.data
        }))  }
};
</script>
